module.exports = __webpack_public_path__ + "img/movistar-arena.78437422.jpg";